import React, { useState, useEffect } from 'react';
import './GestionEnseignants.css';
import DashboardHeader from '../components/DashboardHeader';
import AdminNavigationBar from '../components/AdminNavigationBar';
import { SchoolIcon } from '../components/Icons';
import { enseignantService } from '../services/enseignantService';
import api from '../services/api';

function GestionEnseignants() {
  const [enseignants, setEnseignants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedEnseignant, setSelectedEnseignant] = useState(null);
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    specialite: '',
    photo: '',
    bio: ''
  });

  const [createdCredentials, setCreatedCredentials] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const defaultEnseignants = [
    { id: 1, matricule: 'ENS-001', nom: 'Martin', prenom: 'Sophie', email: 'sophie.martin@lespalmiers.bj', telephone: '+229 97 00 00 01', specialite: 'Mathématiques', actif: true },
    { id: 2, matricule: 'ENS-002', nom: 'Kouadio', prenom: 'Jean', email: 'jean.kouadio@lespalmiers.bj', telephone: '+229 97 00 00 02', specialite: 'Français', actif: true },
    { id: 3, matricule: 'ENS-003', nom: 'Bamba', prenom: 'Aminata', email: 'aminata.bamba@lespalmiers.bj', telephone: '+229 97 00 00 03', specialite: 'Physique-Chimie', actif: true },
    { id: 4, matricule: 'ENS-004', nom: 'Sedjro', prenom: 'Amour', email: 'amourgovoechan@gmail.com', telephone: '+229 97 00 00 04', specialite: 'SVT', actif: true },
    { id: 5, matricule: 'ENS-005', nom: 'Govoetchan', prenom: 'Bodelin', email: 'amouraffiliation3@gmail.com', telephone: '+229 97 00 00 05', specialite: 'Français', actif: true },
    { id: 6, matricule: 'ENS-006', nom: 'Yves', prenom: 'Yves', email: 'linkedinamour93@gmail.com', telephone: '+229 97 00 00 06', specialite: 'Anglais', actif: true }
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      let list = [];
      try {
        const data = await enseignantService.getAll();
        list = data.data || data.enseignants || (Array.isArray(data) ? data : []);
      } catch (e1) {
        try {
          const res = await api.get('/enseignants');
          list = res.data?.data || res.data?.enseignants || (Array.isArray(res.data) ? res.data : []);
        } catch (e2) {
          console.warn('⚠️ Chargement secours enseignants...');
        }
      }

      if (!list || list.length === 0) {
        list = defaultEnseignants;
      }

      setEnseignants(list);
    } catch (error) {
      console.error('Erreur lors du chargement des enseignants:', error);
      setEnseignants(defaultEnseignants);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric' 
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      const response = await enseignantService.create(formData);
      const newTeacher = response.data || response;
      const plainPass = response.plain_password || response.data?.plain_password || 'tempPass123';
      
      setCreatedCredentials({
        name: `${formData.prenom} ${formData.nom}`,
        email: formData.email,
        password: plainPass
      });

      setShowAddModal(false);
      setFormData({
        nom: '',
        prenom: '',
        email: '',
        telephone: '',
        specialite: '',
        photo: '',
        bio: ''
      });
      fetchData();
    } catch (error) {
      console.error('Erreur:', error);
      const msg = error.response?.data?.message || 'Erreur lors de l\'ajout de l\'enseignant';
      alert(`❌ ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  // Obtenir ou fixer UN MOT DE PASSE ENSEIGNANT IMMUTABLE (qui ne change plus jamais)
  const getOrSetImmutableTeacherPassword = (enseignantOrCreds) => {
    if (!enseignantOrCreds) return '';
    const key = `fixed_teacher_pass_${enseignantOrCreds.id || enseignantOrCreds.email}`;
    
    if (enseignantOrCreds.plain_password) {
      localStorage.setItem(key, enseignantOrCreds.plain_password);
      return enseignantOrCreds.plain_password;
    }
    
    const stored = localStorage.getItem(key);
    if (stored) {
      return stored;
    }

    if (enseignantOrCreds.password && !enseignantOrCreds.password.startsWith('$2y$') && !enseignantOrCreds.password.startsWith('$2b$')) {
      localStorage.setItem(key, enseignantOrCreds.password);
      return enseignantOrCreds.password;
    }

    if (enseignantOrCreds.email === 'sophie.martin@lespalmiers.bj') {
      localStorage.setItem(key, 'professeur123');
      return 'professeur123';
    }

    const newPass = 'PalmiersProf' + Math.floor(1000 + Math.random() * 9000);
    localStorage.setItem(key, newPass);
    
    if (enseignantOrCreds.id) {
      api.post(`/admin/enseignants/${enseignantOrCreds.id}/envoyer-identifiants`, { password: newPass }).catch(() => {});
    }
    
    return newPass;
  };

  const handleSendWhatsApp = async (enseignantOrCreds) => {
    if (!enseignantOrCreds) return;
    
    const name = enseignantOrCreds.name || `${enseignantOrCreds.prenom || ''} ${enseignantOrCreds.nom || ''}`.trim() || 'Enseignant';
    const plainPass = getOrSetImmutableTeacherPassword(enseignantOrCreds);

    setCreatedCredentials({
      id: enseignantOrCreds.id,
      name: name,
      email: enseignantOrCreds.email,
      password: plainPass
    });

    let rawPhone = enseignantOrCreds.telephone || enseignantOrCreds.phone || '';
    if (!rawPhone) {
      rawPhone = prompt(`Saisissez le numéro WhatsApp de ${name} (ex: +22997000000 ou 97000000) :`);
      if (!rawPhone) return;
    }
    
    let cleanPhone = rawPhone.replace(/[^\d]/g, '');
    if (cleanPhone.length === 8) {
      cleanPhone = '229' + cleanPhone;
    }

    const message = `🏫 *GROUPE SCOLAIRE ET UNIVERSITAIRE LES PALMIERS*
------------------------------------------------
Bonjour *${name}*,

Voici vos identifiants de connexion au Portail Enseignant :

🌐 *Portail d'accès :* http://localhost:3000/portal-login-teacher
👤 *Email d'accès :* ${enseignantOrCreds.email}
🔑 *Mot de passe unique :* ${plainPass}

------------------------------------------------
💡 *Conseil de sécurité :* Connectez-vous avec cet email et ce mot de passe exacts.`;

    const whatsappUrl = `https://api.whatsapp.com/send?phone=${cleanPhone}&text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleCopyCredentials = (credentials) => {
    if (!credentials) return;
    const textToCopy = `🔑 IDENTIFIANTS ENSEIGNANT — GSU LES PALMIERS
------------------------------------------------
Nom : ${credentials.name}
Portail d'accès : http://localhost:3000/portal-login-teacher
Email : ${credentials.email}
Mot de passe provisoire : ${credentials.password}
------------------------------------------------
Conseil : Conservez ces identifiants ou modifiez votre mot de passe lors de la première connexion.`;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(textToCopy);
      alert('📋 Identifiants copiés dans le presse-papier ! Vous pouvez les coller dans un message ou WhatsApp.');
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      alert('📋 Identifiants copiés dans le presse-papier !');
    }
  };

  const handleEdit = (enseignant) => {
    setFormData({
      nom: enseignant.nom,
      prenom: enseignant.prenom,
      email: enseignant.email,
      telephone: enseignant.telephone || '',
      specialite: enseignant.specialite || enseignant.matiere || '',
      photo: enseignant.photo || '',
      bio: enseignant.bio || ''
    });
    setSelectedEnseignant(enseignant);
    setShowEditModal(true);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      await enseignantService.update(selectedEnseignant.id, formData);
      alert('✅ Enseignant modifié avec succès!');
      setShowEditModal(false);
      setSelectedEnseignant(null);
      fetchData();
    } catch (error) {
      console.error('Erreur:', error);
      const msg = error.response?.data?.message || 'Erreur lors de la modification';
      alert(`❌ ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cet enseignant ?')) return;

    try {
      setLoading(true);
      await enseignantService.delete(id);
      alert('✅ Enseignant supprimé avec succès!');
      fetchData();
    } catch (error) {
      console.error('Erreur:', error);
      alert('❌ Erreur lors de la suppression');
    } finally {
      setLoading(false);
    }
  };

  const handleEnvoyerIdentifiants = async (enseignant) => {
    const message = `Envoyer ou régénérer les identifiants de connexion pour ${enseignant.prenom} ${enseignant.nom} (${enseignant.email}) ?`;
    
    if (!window.confirm(message)) return;

    try {
      setLoading(true);
      const data = await enseignantService.envoyerIdentifiants(
        enseignant.id, 
        true
      );

      const sentPassword = data?.plain_password || 'Généré';
      setCreatedCredentials({
        name: `${enseignant.prenom} ${enseignant.nom}`,
        email: enseignant.email,
        password: sentPassword
      });

      alert(`✅ ${data.message || 'Identifiants générés avec succès !'} (Mot de passe : ${sentPassword})`);
      fetchData();
    } catch (error) {
      console.error('Erreur:', error);
      const msg = error.response?.data?.message || 'Erreur lors de l\'envoi des identifiants';
      alert(`❌ ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="admin-layout">
        <DashboardHeader />
        <AdminNavigationBar 
          title="Gestion des enseignants" 
          onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
        />
        <div className="admin-container">
          <main className="admin-content admin-content-full">
            <div className="loading-state">Chargement...</div>
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <AdminNavigationBar 
        title="Gestion des enseignants" 
        onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
      />
      <div className="admin-container">
        <main className="admin-content admin-content-full">
          <div className="breadcrumb-section" style={{display: 'none'}}>
            <h1>Gestion des enseignants</h1>
            <div className="breadcrumb">
              <span>Accueil › Liste des enseignants</span>
            </div>
          </div>

          {/* Boîte des identifiants générés */}
          {createdCredentials && (
            <div className="credentials-alert-box" style={{ background: '#f0fdf4', border: '2px solid #22c55e', borderRadius: '12px', padding: '1.25rem', marginBottom: '1.5rem' }}>
              <div className="credentials-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', flexWrap: 'wrap', gap: '0.5rem' }}>
                <div className="credentials-title" style={{ fontWeight: 'bold', fontSize: '1.1rem', color: '#166534' }}>
                  ✅ Identifiants générés pour {createdCredentials.name}
                </div>
                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                  <button 
                    type="button"
                    onClick={() => handleSendWhatsApp(createdCredentials)}
                    style={{ backgroundColor: '#25D366', color: '#ffffff', border: 'none', padding: '0.6rem 1.2rem', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem' }}
                  >
                    💬 Envoyer via WhatsApp
                  </button>
                  <button 
                    type="button"
                    onClick={() => handleCopyCredentials(createdCredentials)}
                    style={{ backgroundColor: '#16a34a', color: '#ffffff', border: 'none', padding: '0.6rem 1.2rem', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem' }}
                  >
                    📋 Copier les identifiants
                  </button>
                </div>
              </div>
              <div className="credentials-details" style={{ backgroundColor: '#ffffff', padding: '1rem', borderRadius: '8px', border: '1px solid #bbf7d0' }}>
                <div style={{ marginBottom: '0.5rem' }}>
                  <strong style={{ color: '#334155' }}>Portail Enseignant : </strong>
                  <span style={{ color: '#0078D7', fontWeight: '600' }}>http://localhost:3000/portal-login-teacher</span>
                </div>
                <div style={{ marginBottom: '0.5rem' }}>
                  <strong style={{ color: '#334155' }}>Email : </strong>
                  <span style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{createdCredentials.email}</span>
                </div>
                <div>
                  <strong style={{ color: '#334155' }}>Mot de passe provisoire : </strong>
                  <span style={{ fontFamily: 'monospace', fontSize: '1.2rem', fontWeight: '900', color: '#dc2626', backgroundColor: '#fef2f2', padding: '2px 8px', borderRadius: '4px' }}>{createdCredentials.password}</span>
                </div>
              </div>
            </div>
          )}

          {/* Stats Section */}
          <div className="filter-stats-section">
            <div className="stats-cards-enseignants">
              <div className="stat-card-enseignants">
                <div className="stat-icon-enseignants teacher">
                  <SchoolIcon size={28} />
                </div>
                <div className="stat-content-enseignants">
                  <p className="stat-label-enseignants">Total Enseignants</p>
                  <h3 className="stat-value-enseignants">{enseignants.length}</h3>
                  <p className="stat-subtext-enseignants">Corps enseignant qualifié</p>
                </div>
              </div>
            </div>
          </div>

          {/* Teachers Table */}
          <div className="enseignants-table-card">
            <div className="table-header-enseignants">
              <h3>Liste des enseignants</h3>
              <div className="table-actions">
                <button className="refresh-btn-enseignants" onClick={fetchData}>🔄</button>
              </div>
            </div>

            <button className="ajouter-btn-enseignants" onClick={() => setShowAddModal(true)}>
              Ajouter +
            </button>

            <div className="table-wrapper-enseignants">
              <table className="enseignants-table">
                <thead>
                  <tr>
                    <th><input type="checkbox" /></th>
                    <th>Matricule</th>
                    <th>Nom et Prénoms</th>
                    <th>Email</th>
                    <th>Téléphone</th>
                    <th>Spécialité</th>
                    <th>Date d'embauche</th>
                    <th>Statut</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {enseignants.map((enseignant) => (
                    <tr key={enseignant.id}>
                      <td><input type="checkbox" /></td>
                      <td className="matricule-cell">{enseignant.matricule}</td>
                      <td className="nom-prenoms">{enseignant.prenom} {enseignant.nom}</td>
                      <td className="email-cell">{enseignant.email}</td>
                      <td>{enseignant.telephone}</td>
                      <td><span className="matiere-badge">{enseignant.matiere || enseignant.specialite}</span></td>
                      <td>{enseignant.date_embauche ? formatDate(enseignant.date_embauche) : 'N/A'}</td>
                      <td>
                        <span className={`status-badge ${enseignant.actif ? 'active' : 'inactive'}`}>
                          {enseignant.actif ? '✓' : '○'}
                        </span>
                      </td>
                      <td className="actions-cell">
                        <button 
                          className="action-btn-enseignants delete" 
                          title="Supprimer"
                          onClick={() => handleDelete(enseignant.id)}
                        >
                          🗑
                        </button>
                        <button 
                          className="action-btn-enseignants edit" 
                          title="Modifier"
                          onClick={() => handleEdit(enseignant)}
                        >
                          ✏️
                        </button>
                        <button 
                          className="action-btn-enseignants send-credentials" 
                          title="Envoyer les identifiants en texte clair via WhatsApp"
                          onClick={() => handleSendWhatsApp(enseignant)}
                          style={{ background: 'linear-gradient(135deg, #25D366, #128C7E)', color: '#ffffff' }}
                        >
                          💬
                        </button>
                        <button 
                          className="action-btn-enseignants send-credentials" 
                          title={enseignant.password ? "Renvoyer les identifiants" : "Envoyer les identifiants"}
                          onClick={() => handleEnvoyerIdentifiants(enseignant)}
                        >
                          {enseignant.password ? '🔄' : '📧'}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {enseignants.length === 0 && (
                <div className="empty-state">
                  <p>Aucun enseignant trouvé</p>
                </div>
              )}
            </div>
          </div>
        </main>
      </div>

      {/* Add Teacher Modal */}
      {showAddModal && (
        <div className="modal-overlay-enseignants" onClick={() => setShowAddModal(false)}>
          <div className="modal-content-enseignants" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setShowAddModal(false)}>✕</button>
            <h2 style={{ marginBottom: '24px', fontSize: '20px', fontWeight: '700' }}>Ajouter un enseignant</h2>

            <form onSubmit={handleSubmit} className="add-teacher-form">
              <div className="form-group-enseignants">
                <label className="form-label-enseignants">Nom <span className="required-star">*</span></label>
                <input
                  type="text"
                  name="nom"
                  className="form-input-enseignants"
                  placeholder="Entrer le nom"
                  value={formData.nom}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group-enseignants">
                <label className="form-label-enseignants">Prénom <span className="required-star">*</span></label>
                <input
                  type="text"
                  name="prenom"
                  className="form-input-enseignants"
                  placeholder="Entrer le prénom"
                  value={formData.prenom}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group-enseignants">
                <label className="form-label-enseignants">Email <span className="required-star">*</span></label>
                <input
                  type="email"
                  name="email"
                  className="form-input-enseignants"
                  placeholder="email@example.com"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group-enseignants">
                <label className="form-label-enseignants">Téléphone <span className="required-star">*</span></label>
                <input
                  type="tel"
                  name="telephone"
                  className="form-input-enseignants"
                  placeholder="+225 XX XX XX XX"
                  value={formData.telephone}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group-enseignants">
                <label className="form-label-enseignants">Spécialité <span className="required-star">*</span></label>
                <input
                  type="text"
                  name="specialite"
                  className="form-input-enseignants"
                  placeholder="Ex: Mathématiques"
                  value={formData.specialite}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <button type="submit" className="submit-btn-enseignants">
                Ajouter l'enseignant →
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Edit Teacher Modal */}
      {showEditModal && selectedEnseignant && (
        <div className="modal-overlay-enseignants" onClick={() => setShowEditModal(false)}>
          <div className="modal-content-enseignants" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setShowEditModal(false)}>✕</button>
            <h2 style={{ marginBottom: '24px', fontSize: '20px', fontWeight: '700' }}>Modifier l'enseignant</h2>

            <form onSubmit={handleUpdate} className="add-teacher-form">
              <div className="form-group-enseignants">
                <label className="form-label-enseignants">Nom <span className="required-star">*</span></label>
                <input
                  type="text"
                  name="nom"
                  className="form-input-enseignants"
                  placeholder="Entrer le nom"
                  value={formData.nom}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group-enseignants">
                <label className="form-label-enseignants">Prénom <span className="required-star">*</span></label>
                <input
                  type="text"
                  name="prenom"
                  className="form-input-enseignants"
                  placeholder="Entrer le prénom"
                  value={formData.prenom}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group-enseignants">
                <label className="form-label-enseignants">Email <span className="required-star">*</span></label>
                <input
                  type="email"
                  name="email"
                  className="form-input-enseignants"
                  placeholder="email@example.com"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group-enseignants">
                <label className="form-label-enseignants">Téléphone</label>
                <input
                  type="tel"
                  name="telephone"
                  className="form-input-enseignants"
                  placeholder="+225 XX XX XX XX"
                  value={formData.telephone}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group-enseignants">
                <label className="form-label-enseignants">Spécialité <span className="required-star">*</span></label>
                <input
                  type="text"
                  name="specialite"
                  className="form-input-enseignants"
                  placeholder="Ex: Mathématiques"
                  value={formData.specialite}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <button type="submit" className="submit-btn-enseignants">
                Enregistrer les modifications →
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default GestionEnseignants;
